import { BORDERS, COLORS } from '@alto/design-library-tokens';
import React from 'react';
import { type ImageSourcePropType } from 'react-native';
import { Border } from '../../borders';
import { Column, MdPadding, Row, Touchable } from '../../containers';
import { SizedImage } from '../../images';
import { MdSpacing } from '../../separators';
import { Link, Text } from '../../typography';

type Props = {
  readonly body: string;
  readonly onPress: () => void;
  readonly image?: ImageSourcePropType;
  readonly ctaText?: string;
  readonly accessibilityLabel?: string;
};

export const OptionCard = ({ onPress, body, ctaText, accessibilityLabel, image }: Props) => {
  return (
    <Touchable
      onPress={onPress}
      accessibilityLabel={accessibilityLabel}
      borderRadius={BORDERS.RADIUS.LG.value}
    >
      <Border
        radius="LG"
        color={COLORS.PALETTE.PRIMARY.DEFAULT}
      >
        <MdPadding>
          <Row
            centerVertically
            spaceBetween
          >
            <Column
              flexShrink={1}
              spaceBetween
            >
              <Text fontFamily="semibold">{body}</Text>
              {!!ctaText && (
                <>
                  <MdSpacing />
                  <Link fontFamily="semibold">{ctaText}</Link>
                </>
              )}
            </Column>
            {!!image && (
              <>
                <MdSpacing />
                <SizedImage
                  accessibilityLabel={accessibilityLabel}
                  pixelSize={60}
                  source={image}
                />
              </>
            )}
          </Row>
        </MdPadding>
      </Border>
    </Touchable>
  );
};
